export const TICKET_CLOSED_CODE = 'TICKET_CLOSED';
export const TICKET_CLOSED_NAME = 'Ticket Closed';

export const isTicketClosed = (s) =>
  (s?.code && String(s.code).toUpperCase() === TICKET_CLOSED_CODE) ||
  (s?.name && s.name.trim().toLowerCase() === TICKET_CLOSED_NAME.toLowerCase());

export const makeTicketClosed = (pos = 1) => ({
  id: null,
  code: TICKET_CLOSED_CODE,
  name: TICKET_CLOSED_NAME,
  position: pos,
});

/** Ensure exactly one "Ticket Closed" exists and it is last */
export function normalizeWithTicketClosed(stages) {
  const nonTC = (stages || []).filter((s) => !isTicketClosed(s));
  const tc = (stages || []).find(isTicketClosed) ?? makeTicketClosed();
  return [...nonTC, { ...tc }];
}